<template lang="pug">
  .component-tabbed-vehicle-availability
    .action-bar
      .title
        h2 Availability
    .tabs-inner-content
      search-vehicle-availability(:vehicle="vehicle", @slotsSelected="book")
        label Driver
          selectize-driver(@optionSelected="selectDriver")

</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import BackofficeVehicleAvailability from "../VehicleAvailability";
  import DatePicker from "../../structure/DatePicker";
  import SelectizeDriver from "../../structure/ui/lists/selectize/SelectizeDriver";
  import MaggieHelper from "../../../maggieHelper";
  import SearchVehicleAvailability from "../SearchVehicleAvailability";

  export default {
    name: "TabbedVehicleAvailability",
    components: {
      SearchVehicleAvailability,
      SelectizeDriver,
      DatePicker,
      BackofficeVehicleAvailability
    },
    data() {
      return {
        vehicle: null,
        bookRequest: {
          plate: null,
          start: null,
          end: null,
          driver_id: null,
        }
      }
    },
    created() {
      KeplerBackofficeSdk.vehicles.select(this.$route.params.id).get((data) => {
        this.vehicle = data
        this.bookRequest.plate = data.plate
      })
    },
    methods: {
      selectDriver(obj) {
        this.bookRequest.driver_id = obj.id
      },

      book(data) {

        this.bookRequest = Object.assign(this.bookRequest, data)

        KeplerBackofficeSdk.reservations.make(this.bookRequest, (response) => {
          this.reservation = response;
          this.vehicles = []
          MaggieHelper.notification('book-esit', "reservation created");
          this.$emit('reservationCreated')
        })
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-availability
    background: white

</style>



// WEBPACK FOOTER //
// VehicleAvailability.vue?93c7bf50